module.exports = __webpack_public_path__ + "static/img/icon.06b8f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/icon.jpg
// module id = ctEz
// module chunks = 0